import React from "react";
import { FormColumn, FormColumn2Wide, Paper, RadioGroup, Select, Typography } from "best-common-react";
import { useTranslation } from "react-i18next";
import { useProspectProfile } from "../../../contexts/ProsepctProfileContext";
import { useDropdowns } from "../../../contexts/DropdownsContext";
import AcademicLevelupInput from "./education/AcademicLevelupInput";
import { CountryIds } from "../../../constants/CountryConstants";
import CubanBornEducationInfo from "./education/CubanBornEducationInfo";

const ProspectEducationInformationSection: React.FC = () => {
  const { t } = useTranslation(["profile", "translation"]);
  const { profile, updateProfileField, updateMultipleProfileFields } = useProspectProfile();
  const { yesNoRadioValues, getYesNoRadioValues, academicLevelYearOptions } = useDropdowns();

  return (
    <div>
      <Paper className="mb-3">{t("profile:educationSection")}</Paper>
      <div className="row pt-2">
        <FormColumn2Wide>
          <RadioGroup
            id="currently-attending-school"
            label={t("profile:currentlyAttending")}
            name="currentlyAttendingSchool"
            className="pb-2"
            options={yesNoRadioValues.sort((a, b) => (a.value > b.value ? -1 : 1))}
            value={getYesNoRadioValues(profile?.currentlyAttendingSchool)?.value}
            onChange={(value) => {
              updateMultipleProfileFields({
                currentlyAttendingSchool: value === 1,
                highestProspectAcademicLevelId: undefined,
                highestProspectAcademicLevelWriteIn: undefined,
              });
            }}
          />
        </FormColumn2Wide>
      </div>

      {profile?.currentlyAttendingSchool && (
        <div className="mt-2">
          <Typography variant="subtitle1" className="m-0">
            {t("profile:highestGradeQuestion")}
          </Typography>
          <div className="row pt-2">
            <FormColumn width={2}>
              <AcademicLevelupInput
                id="prospect-academic-level"
                idValue={profile.highestProspectAcademicLevelId}
                writeIn={profile.highestProspectAcademicLevelWriteIn}
                onChange={(idValue, writeIn) => {
                  updateMultipleProfileFields({
                    highestProspectAcademicLevelId: idValue,
                    highestProspectAcademicLevelWriteIn: writeIn,
                  });
                }}
              />
            </FormColumn>
            <FormColumn width={2}>
              <Select
                id="year-select"
                options={academicLevelYearOptions}
                label={t("translation:year")}
                placeholder={t("translation:selectPlaceholder")}
                value={academicLevelYearOptions.find(
                  (option) => option.value === profile.highestProspectAcademicLevelYear,
                )}
                onChange={(value) => {
                  updateProfileField("highestProspectAcademicLevelYear", value?.value);
                }}
              />
            </FormColumn>
          </div>
        </div>
      )}

      <div className="mt-3">
        <Typography variant="subtitle1" className="mb-1">
          {t("profile:highestParentGrade")}
        </Typography>
        <AcademicLevelupInput
          id="parent-academic-level"
          idValue={profile.highestParentAcademicLevelId}
          writeIn={profile.highestParentAcademicLevelWriteIn}
          onChange={(idValue, writeIn) => {
            updateMultipleProfileFields({
              highestParentAcademicLevelId: idValue,
              highestParentAcademicLevelWriteIn: writeIn,
            });
          }}
        />
      </div>

      {profile?.birthCountryId === CountryIds.CUBA && <CubanBornEducationInfo />}
    </div>
  );
};

export default ProspectEducationInformationSection;
